<h1 mat-dialog-title class="p-2 text-center">Modification de la mesure</h1>
<div mat-dialog-content class="p-3">

    <div class="row my-3">
        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="Model.PumpWithBattery">
            Batterie*
        </mat-slide-toggle>

        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="Model.Rush">
            Express*
        </mat-slide-toggle>

        @if (IsDispatch) {
        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="Model.HasFan">
            Ventilateur*
        </mat-slide-toggle>
        }
        @if (IsDispatch && WithAccredited) {
        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="Model.IsAccredited">
            Accrédité
        </mat-slide-toggle>
        }
    </div>

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()">
            Ajouter
        </button>
    </div>
</div>